import { registerStimulusFeature } from "./stimulus-feature-loader";

registerStimulusFeature("ticket-chat-stream", () =>
  import("./controllers/ticket_chat_stream_controller")
);

registerStimulusFeature("ticket-chat-recorder", () =>
  import("./controllers/ticket_chat_recorder_controller")
);

registerStimulusFeature("ticket-action-plan", () =>
  import("./controllers/ticket_action_plan_controller")
);

registerStimulusFeature("ticket-chat-scroll", () =>
  import("./controllers/ticket_chat_scroll_controller")
);

registerStimulusFeature("ticket-email-preview", () =>
  import("./controllers/ticket_email_preview_controller")
);
